module.exports = __webpack_public_path__ + "static/zh-Hant-b459e20e393d0132103763c04ecfbea9.png";